/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'header';
const componentName = 'avi-main-header-tenant-selector';
const prefix = `${moduleName}.${componentName}`;

export const allTenantsLabel = `${prefix}.allTenantsLabel`;
export const tenantViewLabel = `${prefix}.tenantViewLabel`;

export const ENGLISH = {
    [allTenantsLabel]: 'All Tenants',
    [tenantViewLabel]: 'Tenant View',
};
